import { render } from "./User_Profile.vue?vue&type=template&id=63daf36a"
import script from "./User_Profile.vue?vue&type=script&lang=js"
export * from "./User_Profile.vue?vue&type=script&lang=js"

import "./User_Profile.vue?vue&type=style&index=0&id=63daf36a&lang=css"

import exportComponent from "/home/runner/work/Smart2Docs_Front-end/Smart2Docs_Front-end/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__